export const Status = {
    Idle : "idle",
    Loading: "loading",
    Failed : "failed"
}
